/**
 * SimilarList — `review.similar[]` beside its clause (§13.7's first Verify
 * assertion: "clause list shows ... similarity matches"). `review.similar`
 * is §5.9's shape exactly, `{ accepted_language_id, score }` and nothing
 * else (session 4 FACTS 5) — no route exposes the matched text itself, so
 * this list renders rank + score and states that gap rather than fabricating
 * a snippet or hiding the list (G3, DECISION d).
 */
import type { ClauseSimilarMatch } from '../../api/clauses';

interface SimilarListProps {
  similar: ClauseSimilarMatch[];
  clauseId: string;
}

export function SimilarList({ similar, clauseId }: SimilarListProps) {
  if (similar.length === 0) {
    return (
      <p data-testid={`ctr-similar-empty-${clauseId}`} className="mt-2 text-xs text-gray-500 dark:text-gray-400">
        No accepted language on this topic yet.
      </p>
    );
  }

  return (
    <div className="mt-2 space-y-1">
      <p className="text-xs font-medium text-gray-600 dark:text-gray-300">Similar accepted language</p>
      <ul className="space-y-1">
        {similar.map((s, idx) => (
          <li
            key={s.accepted_language_id}
            data-testid={`ctr-similar-${clauseId}-${idx}`}
            title={`accepted-language id: ${s.accepted_language_id}`}
            className="flex items-center gap-2 text-xs text-gray-700 dark:text-gray-300"
          >
            <span className="tabular-nums font-medium">#{idx + 1}</span>
            <span className="tabular-nums" title={`score: ${s.score}`}>
              {Math.round(s.score * 100)}%
            </span>
          </li>
        ))}
      </ul>
      <p className="text-[11px] text-gray-400 dark:text-gray-500">
        The matched text itself is not yet exposed by any route — only the score and id above.
      </p>
    </div>
  );
}

export default SimilarList;
